interface Props {
  width?: number;
  height?: number;
  hexColor?: string;
  hexColor2?: string;
  checked: boolean;
}

export const Checkbox = ({
  width = 11,
  height = 11,
  hexColor = "white",
  hexColor2 = 'black',
  checked = false
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Rounded rectangle border */}
      <rect
        x={0.5}
        y={0.5}
        width={11}
        height={11}
        rx={2}
        ry={2}
        fill={hexColor}
        stroke={checked ? hexColor2 : '#D6D4D7'}
        strokeWidth={1}
      />
      {/* Checkmark, visible only if checked */}
      {checked ? 
        <path 
          d="M3.47155 6.94391L0 3.47154L1.15691 2.31464L3.47155 4.62845L8.09918 0L9.25691 1.15773L3.47155 6.94391Z" 
          fill={hexColor2}
          transform="translate(3 4) scale(0.6)"
        />
        : <></>
      }
    </svg>
  );
};

export default Checkbox;
